export default {"src":"/_next/static/media/NeonatalSurgery.479bd09e.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};